// Logout page - handles logout for all apps (CRM, DeliveryHub, Blog, ERP)
import { useEffect } from 'react';
import { AuthService } from '@/services/authService';
import { isErpHost } from '@/utils/erp-host';
import { Loader2 } from 'lucide-react';

const Logout = () => {
  useEffect(() => {
    const performLogout = async () => {
      // On the ERP subdomain (erp.*), stay on the ERP login — the configured
      // VITE_LOGOUT_REDIRECT_URL points at the CRM host, so ignore it here.
      const logoutRedirectUrl = isErpHost()
        ? '/login'
        : (import.meta.env.VITE_LOGOUT_REDIRECT_URL || '/login');

      await AuthService.logout({
        clearLocalStorage: true,
        clearSessionStorage: true,
        clearIndexedDB: true,
        notifyBackend: true,
        redirectTo: logoutRedirectUrl
      });
    };

    performLogout();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-brand mx-auto mb-4" />
        <p className="text-gray-600">Signing out...</p>
      </div>
    </div>
  );
};

export default Logout;
